import { HandMainKey } from '@lbs/shared-rp-types'
import { z } from 'zod'

// Схема валидации формы для RpPayouts
// Ниже — примеры различных типов валидации.
// Раскомментируйте/добавьте нужные поля, адаптируйте под свою модель.

const handMainKeys: [HandMainKey, ...HandMainKey[]] = [
  'HIGH_CARD',
  'ACE_KING',
  'ONE_PAIR',
  'TWO_PAIRS',
  'THREE_OF_A_KIND',
  'STRAIGHT',
  'FLUSH',
  'FULL_HOUSE',
  'FOUR_OF_A_KIND',
  'STRAIGHT_FLUSH',
  'ROYAL_FLUSH',
]

const rpCombinationMultiplierSchema = z.object({
  combination: z.enum(handMainKeys),
  multiplier: z.number(),
})

export const RpPayoutsSchema = z.object({
  name: z.string().min(1, { message: 'Имя обязательно' }),
  data: z.array(rpCombinationMultiplierSchema),
})

export type TRpPayoutsFormData = z.infer<typeof RpPayoutsSchema>
